// @ts-strict-ignore
import * as React from 'react';
import { SpinnerReact } from 'common/components/spinner';
import { useTranslation } from 'common/i18n/hooks';
import { BarPreview } from './charts/bar';
import { ChartPreviewCarousel } from './chart-preview-carousel';
import { FunnelPreview } from './charts/funnel';
import { LinePreview } from './charts/line';
import { FunnelBreakdownPreview } from './charts/funnel-breakdown';
const CHART_PREVIEW_MAX = 4;
export const EventChartPreviewCarousel = _ref => {
  let {
    events
  } = _ref;
  const {
    t
  } = useTranslation();
  if (!events || events.length === 0) {
    return <SpinnerReact />;
  }
  const eventsToShow = events.slice(0, CHART_PREVIEW_MAX);
  return <ChartPreviewCarousel data-sentry-element="ChartPreviewCarousel" data-sentry-component="EventChartPreviewCarousel" data-sentry-source-file="index.tsx">
      <FunnelPreview events={eventsToShow} cardTitle={t("onboarding-legacy.chart.funnel-title")} data-sentry-element="FunnelPreview" data-sentry-source-file="index.tsx" />
      <LinePreview events={eventsToShow} cardTitle={t("onboarding-legacy.chart.line-default-title")} data-sentry-element="LinePreview" data-sentry-source-file="index.tsx" />
      <BarPreview events={eventsToShow} cardTitle={t("onboarding-legacy.chart.bar-default-title")} data-sentry-element="BarPreview" data-sentry-source-file="index.tsx" />
    </ChartPreviewCarousel>;
};
export const PropertyBreakdownPreviewCarouselV2 = _ref2 => {
  let {
    events,
    property,
    breakdown,
    pauseRotation,
    selectedEvent
  } = _ref2;
  const {
    t
  } = useTranslation();
  let toShow = [];
  if (!(breakdown !== null && breakdown !== void 0 && breakdown.length)) {
    toShow = ["Property A", "Property B", "Property C"];
  } else {
    toShow = breakdown.slice(0, CHART_PREVIEW_MAX);
  }
  const LineCardDefaultTitle = t("onboarding.chart.line-default-title");
  const FunnelBreakdownCardDefaultTitle = t("onboarding.chart.funnel-breakdown-default-title");
  const BarCardDefaultTitle = t("onboarding.chart.bar-default-title");
  const cardTitle = t("onboarding.chart.breakdown-custom-title", {
    selectedEvent,
    property
  });
  const missingTitleInfo = !selectedEvent || !property;
  return <ChartPreviewCarousel pauseRotation={pauseRotation} data-sentry-element="ChartPreviewCarousel" data-sentry-component="PropertyBreakdownPreviewCarouselV2" data-sentry-source-file="index.tsx">
      <LinePreview events={toShow} cardTitle={missingTitleInfo ? LineCardDefaultTitle : cardTitle} data-sentry-element="LinePreview" data-sentry-source-file="index.tsx" />
      <FunnelBreakdownPreview events={events.slice(0, CHART_PREVIEW_MAX)} property={property} properties={toShow} cardTitle={missingTitleInfo ? FunnelBreakdownCardDefaultTitle : cardTitle} data-sentry-element="FunnelBreakdownPreview" data-sentry-source-file="index.tsx" />
      <BarPreview events={toShow} cardTitle={missingTitleInfo ? BarCardDefaultTitle : cardTitle} data-sentry-element="BarPreview" data-sentry-source-file="index.tsx" />
    </ChartPreviewCarousel>;
};